"use client";

import Link from "next/link";
import PropertyListingCard from "@/components/bnp-ui/listing-card/PropertyListingCard";
import type { Property } from "@/types/property";

interface Props {
  property: Property;
}

export default function StatePropertyCard({ property }: Props) {
  return (
    <Link href={`/property/${property.id}`} className="block h-full">
      <PropertyListingCard property={property} />
    </Link>
  );
}
